import React from 'react';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { styled } from '@mui/material/styles';

const CustomPickersDay = styled(PickersDay, {
    shouldForwardProp: (prop) => prop !== 'isSelected' && prop !== 'isHovered',
})(({ theme, isSelected, isHovered, isOutOfLimit, day }) => ({
    borderRadius: 0,
    ...(isOutOfLimit && {
        "backgroundColor": theme.palette.action.disabledBackground,
        "color": theme.palette.text.disabled,
        "&:hover, &:focus": {
            backgroundColor: theme.palette.action.disabledBackground,
        },
    }),
    ...(isSelected && {
        "backgroundColor": theme.palette.primary.main,
        "color": theme.palette.primary.contrastText,
        '&:hover, &:focus': {
            backgroundColor: theme.palette.primary.main,
        },
    }),
    ...(isHovered && {
        "backgroundColor": theme.palette.primary[theme.palette.mode],
        '&:hover, &:focus': {
            backgroundColor: theme.palette.primary[theme.palette.mode],
        },
    }),

}));

export const Day = (props) => {
    const { startDate, endDate, day, limit, ...other } = props;
    let isSelected = day.isBetween(startDate, endDate, 'day', '[]');
    let isHovered = day.isBetween(startDate, endDate, 'day', '()');

    // disable selection for days outside the limit
    // limit is a number of days before and after the startDate

    const isValidStart = startDate && startDate.isValid() && limit && limit > 0;

    let isOutOfLimit = false;

    const maxDate = isValidStart ? startDate.clone().add(limit - 1, 'day') : null;

    isOutOfLimit = day.isAfter(maxDate);

    return (
        <CustomPickersDay
            isSelected={isSelected}
            isHovered={isHovered}
            disabled={isOutOfLimit}
            isOutOfLimit={isOutOfLimit}
            day={day}
            {...other}
        />
    );
};

